var _g, _g2, _mask, _g3, _path, _g4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHrm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_6730_35016)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5922 9.11641C10.5922 11.0252 9.0448 12.5727 7.13596 12.5727C5.22713 12.5727 3.67971 11.0252 3.67971 9.11641C3.67971 7.20757 5.22713 5.66016 7.13596 5.66016C9.0448 5.66016 10.5922 7.20757 10.5922 9.11641ZM3.67963 14.3029H10.5921C12.5017 14.3029 14.0484 15.8496 14.0484 17.7592C14.0484 19.6688 12.5017 21.2154 10.5921 21.2154H3.67963C1.77005 21.2154 0.223373 19.6688 0.223373 17.7592C0.223373 15.8496 1.77005 14.3029 3.67963 14.3029Z",
    fill: "url(#paint0_linear_6730_35016)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_6730_35016)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3202 9.11641C22.3202 11.0252 20.7728 12.5727 18.864 12.5727C16.9552 12.5727 15.4077 11.0252 15.4077 9.11641C15.4077 7.20757 16.9552 5.66016 18.864 5.66016C20.7728 5.66016 22.3202 7.20757 22.3202 9.11641ZM15.4077 14.3029H22.3202C24.2297 14.3029 25.7764 15.8496 25.7764 17.7592C25.7764 19.6688 24.2297 21.2154 22.3202 21.2154H15.4077C13.4981 21.2154 11.9514 19.6688 11.9514 17.7592C11.9514 15.8496 13.4981 14.3029 15.4077 14.3029Z",
    fill: "url(#paint1_linear_6730_35016)"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-1_6730_35016",
    maskUnits: "userSpaceOnUse",
    x: 3.34598,
    y: 2.5625,
    width: 20,
    height: 21,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 3.34598,
    y: 2.5625,
    width: 20,
    height: 21
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3274 7.88956C17.3274 10.2793 15.3901 12.2166 13.0003 12.2166C10.6105 12.2166 8.67325 10.2793 8.67325 7.88956C8.67325 5.49979 10.6105 3.5625 13.0003 3.5625C15.3901 3.5625 17.3274 5.49979 17.3274 7.88956ZM8.67304 13.7905H17.3272C19.7179 13.7905 21.6542 15.7268 21.6542 18.1175C21.6542 20.5082 19.7179 22.4446 17.3272 22.4446H8.67304C6.28234 22.4446 4.34598 20.5082 4.34598 18.1175C4.34598 15.7268 6.28234 13.7905 8.67304 13.7905Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_6730_35016)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3274 7.88956C17.3274 10.2793 15.3901 12.2166 13.0003 12.2166C10.6105 12.2166 8.67325 10.2793 8.67325 7.88956C8.67325 5.49979 10.6105 3.5625 13.0003 3.5625C15.3901 3.5625 17.3274 5.49979 17.3274 7.88956ZM8.67304 13.7905H17.3272C19.7179 13.7905 21.6542 15.7268 21.6542 18.1175C21.6542 20.5082 19.7179 22.4446 17.3272 22.4446H8.67304C6.28234 22.4446 4.34598 20.5082 4.34598 18.1175C4.34598 15.7268 6.28234 13.7905 8.67304 13.7905Z",
    fill: "url(#paint2_linear_6730_35016)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0003 13.2166C15.9424 13.2166 18.3274 10.8316 18.3274 7.88956H16.3274C16.3274 9.72705 14.8378 11.2166 13.0003 11.2166V13.2166ZM7.67325 7.88956C7.67325 10.8316 10.0583 13.2166 13.0003 13.2166V11.2166C11.1628 11.2166 9.67325 9.72705 9.67325 7.88956H7.67325ZM13.0003 2.5625C10.0583 2.5625 7.67325 4.94751 7.67325 7.88956H9.67325C9.67325 6.05208 11.1628 4.5625 13.0003 4.5625V2.5625ZM18.3274 7.88956C18.3274 4.94751 15.9424 2.5625 13.0003 2.5625V4.5625C14.8378 4.5625 16.3274 6.05208 16.3274 7.88956H18.3274ZM17.3272 12.7905H8.67304V14.7905H17.3272V12.7905ZM22.6542 18.1175C22.6542 15.1745 20.2702 12.7905 17.3272 12.7905V14.7905C19.1656 14.7905 20.6542 16.2791 20.6542 18.1175H22.6542ZM17.3272 23.4446C20.2702 23.4446 22.6542 21.0605 22.6542 18.1175H20.6542C20.6542 19.9559 19.1656 21.4446 17.3272 21.4446V23.4446ZM8.67304 23.4446H17.3272V21.4446H8.67304V23.4446ZM3.34598 18.1175C3.34598 21.0605 5.73005 23.4446 8.67304 23.4446V21.4446C6.83462 21.4446 5.34598 19.9559 5.34598 18.1175H3.34598ZM8.67304 12.7905C5.73005 12.7905 3.34598 15.1745 3.34598 18.1175H5.34598C5.34598 16.2791 6.83462 14.7905 8.67304 14.7905V12.7905Z",
    fill: "white",
    mask: "url(#path-3-outside-1_6730_35016)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_6730_35016)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3274 7.88956C17.3274 10.2793 15.3901 12.2166 13.0003 12.2166C10.6105 12.2166 8.67325 10.2793 8.67325 7.88956C8.67325 5.49979 10.6105 3.5625 13.0003 3.5625C15.3901 3.5625 17.3274 5.49979 17.3274 7.88956ZM8.67304 13.7905H17.3272C19.7179 13.7905 21.6542 15.7268 21.6542 18.1175C21.6542 20.5082 19.7179 22.4446 17.3272 22.4446H8.67304C6.28234 22.4446 4.34598 20.5082 4.34598 18.1175C4.34598 15.7268 6.28234 13.7905 8.67304 13.7905Z",
    fill: "url(#paint3_linear_6730_35016)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_6730_35016",
    x: 0.223373,
    y: 5.66016,
    width: 13.825,
    height: 15.5547,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6730_35016"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_6730_35016",
    x: 11.9514,
    y: 5.66016,
    width: 13.825,
    height: 15.5547,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6730_35016"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_6730_35016",
    x: 3.34598,
    y: 2.5625,
    width: 19.3083,
    height: 20.8828,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6730_35016"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_6730_35016",
    x: 4.34598,
    y: 3.5625,
    width: 17.3083,
    height: 18.8828,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6730_35016"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6730_35016",
    x1: 7.13588,
    y1: 5.66016,
    x2: 7.13588,
    y2: 21.2154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD5DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6730_35016",
    x1: 18.8639,
    y1: 5.66016,
    x2: 18.8639,
    y2: 21.2154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD5DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6730_35016",
    x1: 13.0001,
    y1: 3.5625,
    x2: 13.0001,
    y2: 22.4446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5CBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4ABB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6730_35016",
    x1: 13.0001,
    y1: 3.5625,
    x2: 13.0001,
    y2: 22.4446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5CBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4ABB9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHrm);
export default __webpack_public_path__ + "static/media/hrm.515190a360b6ab087a77577b96d06fdb.svg";
export { ForwardRef as ReactComponent };